module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-week-8be2569a.svg";